import styled from 'styled-components';
import { color } from 'styled-system';

/**
 * Typography for the dutchie+ is a little different than whats in DDS
 * keeping the design token names the same, values are just different.
 */

const Heading1 = styled.h1`
  font-size: 65px;
  line-height: 78px;
  ${color};
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    font-size: 34px;
    line-height: 40px;
  }
`;
const Heading2 = styled.h2`
  font-size: 38px;
  line-height: 44px;
  ${color};
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    font-size: 1.625em;
    line-height: 26px;
  }
`;
const Heading3 = styled.h3`
  font-size: 1.563em;
  ${color};
`;
const Heading4 = styled.h4``;
const Heading5 = styled.h5``;

const Paragraph = styled.p`
  font-size: 16px;
  line-height: 28px;
  ${color};
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    font-size: 0.875em;
    line-height: 22px;
  }
`;

const LargeParagraph = styled(Paragraph)``;
const SubParagraph = styled(Paragraph)`
  font-size: 1em;
  line-height: 26px;
`;

const Subtext = styled.p`
  font-size: 0.813em;
  line-height: 13px;
  ${color};
  font-weight: 700;
  text-transform: uppercase;
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    font-size: 0.75em;
    line-height: 18px;
  }
`;

const LargeCapsSubtext = styled(Subtext)`
  font-size: 15px;
  line-height: 15px;
  font-weight: bold;
  text-transform: uppercase;
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    font-size: 0.75em;
  }
`;

const SmallCapsSubtext = styled(Subtext)`
  font-size: 12px;
  line-height: 13.45px;
  font-weight: bold;
  text-transform: uppercase;
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    font-size: 0.625em;
    line-height: 10px;
  }
`;

const ParagraphLink = styled(Paragraph)`
  color: var(--dct--customized-colors-buttonsLinks);
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const FeatureHeading = styled(Paragraph)`
  font-size: 18px;
  line-height: 23px;
  font-weight: 700;
`;

const FeatureParagraph = styled(Paragraph)`
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
`;

export {
  FeatureHeading,
  FeatureParagraph,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  LargeParagraph,
  Paragraph,
  SubParagraph,
  LargeCapsSubtext,
  SmallCapsSubtext,
  Subtext,
  ParagraphLink,
};
